export default __webpack_public_path__ + "static/media/Rectangle 1011.d342c45b.png";